"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.STATUS_OK = exports.STATUS_NOT_FOUND = exports.STATUS_INTERNAL_SERVER_ERROR = void 0;
var STATUS_OK = exports.STATUS_OK = 200;
var STATUS_NOT_FOUND = exports.STATUS_NOT_FOUND = 404;
var STATUS_INTERNAL_SERVER_ERROR = exports.STATUS_INTERNAL_SERVER_ERROR = 500; //# sourceMappingURL=statusCodes.js.map
